import { render, staticRenderFns } from "./viewFeedBackUserDetail.vue?vue&type=template&id=72414808&scoped=true"
import script from "./viewFeedBackUserDetail.vue?vue&type=script&lang=js"
export * from "./viewFeedBackUserDetail.vue?vue&type=script&lang=js"
import style0 from "./viewFeedBackUserDetail.vue?vue&type=style&index=0&id=72414808&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72414808",
  null
  
)

export default component.exports